import {
    IonContent, IonHeader, IonPage,
    IonTitle, IonToolbar, IonButtons, IonMenuButton,
    IonSearchbar, IonFab, IonFabButton, IonIcon,
    IonRefresher, IonRefresherContent, IonInfiniteScroll, IonInfiniteScrollContent
} from '@ionic/react';
import { add, chevronDownCircleOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import Farms from '../components/Farms';
import { doReload } from '../hooks/common';
import useNavigation from '../hooks/useNavigation';
import { getFarms } from '../services/farm.service';
// debounce hook
import useDebounce from "../hooks/useDebounce";
import CustomSearchBox from '../components/CustomSearchBox/CustomSearchBox';

const FarmList: React.FC = () => {
    const [searchText, setSearchText] = useState('');
    const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(false);
    const [skip, setSkip] = useState<number>(20);
    const navigateTo = useNavigation();
    const debounceSearchText = useDebounce(searchText, 1000);

    const [farms, setFarms] = useState([] as any[]);
    useEffect(() => {
        let mounted = true;
        setSkip(20);
        setDisableInfiniteScroll(false);
        getFarms(debounceSearchText)
            .then(items => {
                if (mounted) {
                    setFarms(items);
                }
            });
        return () => { mounted = false };
    }, [debounceSearchText]);

    async function fetchNext($event: CustomEvent<void>) {
        setSkip(skip + 20);
        getFarms(debounceSearchText, skip)
            .then(items => {
                if (items?.length > 0) {
                    setFarms([...farms, ...items]);
                    setDisableInfiniteScroll(items.length < 20);
                } else {
                    setDisableInfiniteScroll(true);
                }
                ($event.target as HTMLIonInfiniteScrollElement).complete();
            });
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Farms</IonTitle>
                </IonToolbar>
                <CustomSearchBox setSearchText={setSearchText} />
            </IonHeader>
            <IonContent>
                <IonRefresher slot="fixed" onIonRefresh={doReload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>
                <Farms farms={farms} />
                <IonInfiniteScroll threshold="100px"
                    disabled={disableInfiniteScroll}
                    onIonInfinite={(e: CustomEvent<void>) => fetchNext(e)}>
                    <IonInfiniteScrollContent
                        loadingText="Loading more...">
                    </IonInfiniteScrollContent>
                </IonInfiniteScroll>
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton>
                        <IonIcon icon={add} onClick={() => navigateTo('/tabs/farm', { farmId: null })} />
                    </IonFabButton>
                </IonFab>
            </IonContent>
        </IonPage>
    );
};

export default FarmList;
